import React from "react";
import "../../css/footer.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="footer__inner">
        <div className="footer__bottom">
          <div className="footer__legal">
            <Link onClick={toTop} to="/privacy">
              プライバシーポリシー
            </Link>
            <Link onClick={toTop} to="/terms">
              利用規約
            </Link>
            <Link onClick={toTop} to="/legal">
              特定商取引法に基づく表記
            </Link>
          </div>
          <div className="footer__social-copyright">
            <div className="footer__social">
              <a
                href="https://www.facebook.com/readyfor/"
                aria-label="Facebook"
              >
                <img src="/svg-jp/f1-1.svg" alt="Facebook" />
              </a>
              <a href="https://x.com/READYFOR_cf" aria-label="X">
                <img src="/svg-jp/f1-2.svg" alt="X" />
              </a>
              <a
                href="https://line.me/R/ti/p/@lbw2411m?from=page&openQrModal=true&searchId=lbw2411m"
                aria-label="Line"
              >
                <img src="/svg-jp/f1-3.svg" alt="Line" />
              </a>
              <a
                href="https://blog.readyfor.jp/?gs=32ac38cdcb2e"
                aria-label="Note"
              >
                <img src="/svg-jp/f1-4.svg" alt="Note" />
              </a>
            </div>
            <div className="footer__copyright">
              Copyright 2011 READYFOR, Inc. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
